import { createPortal } from "react-dom"
import { useTranslation } from "react-i18next"

export function LoadingOverlay({ isLoading, text }: { isLoading: boolean; text?: string }) {
  const { t } = useTranslation()
  if (!isLoading) return null
  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/20 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl px-10 py-8 flex flex-col items-center gap-4">
        <div className="animate-wobble">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Book back cover */}
            <rect x="10" y="14" width="36" height="40" rx="3" fill="#8B5E3C" />
            {/* Book pages */}
            <rect x="12" y="16" width="32" height="36" rx="2" fill="#FFF8EE" />
            {/* Page lines */}
            <line x1="18" y1="24" x2="38" y2="24" stroke="#D4C4A8" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="18" y1="30" x2="36" y2="30" stroke="#D4C4A8" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="18" y1="36" x2="34" y2="36" stroke="#D4C4A8" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="18" y1="42" x2="30" y2="42" stroke="#D4C4A8" strokeWidth="1.5" strokeLinecap="round" />
            {/* Book spine shadow */}
            <rect x="10" y="14" width="4" height="40" rx="1" fill="#6B3F1F" />
            {/* Pencil */}
            <g transform="translate(40, 20) rotate(15)">
              <rect x="0" y="0" width="6" height="24" rx="1" fill="#F5C542" />
              <polygon points="0,24 6,24 3,32" fill="#F5DFA0" />
              <polygon points="2,30 4,30 3,33" fill="#333" />
              <rect x="0" y="0" width="6" height="4" rx="1" fill="#E88B8B" />
            </g>
          </svg>
        </div>
        <p className="text-sm text-muted-foreground">{text ?? t('common.loading')}</p>
      </div>
    </div>,
    document.body
  )
}
